var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvanceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 32,
    viewBox: "0 0 154 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5617 25.8381C13.6998 25.6797 13.8352 25.5185 13.9732 25.3573L3.20034 10.3418C1.21087 12.6411 0 15.6738 0 18.9992C0 22.2414 1.15098 25.2015 3.05452 27.4794C7.4501 30.7377 12.0488 27.5976 13.5617 25.8381Z",
    fill: "url(#paint0_linear_13237_5564)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1528 16.8367L15.5902 15.2761L30.3472 0L19.7931 8.31629C17.7541 6.85503 15.2803 5.99547 12.6086 5.99547C10.3509 5.99547 8.23382 6.61059 6.40059 7.68236L4.12988 6.13246L12.4992 15.0263L14.1528 16.8367Z",
    fill: "url(#paint1_linear_13237_5564)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5617 25.8379C12.0488 27.5973 7.45011 30.7374 3.05192 27.4791C3.04932 27.4764 3.04671 27.4737 3.0415 27.471L3.25243 27.7182C3.25503 27.7209 3.26024 27.7262 3.26285 27.7289C3.40346 27.8874 3.54668 28.0432 3.69511 28.1963C3.71855 28.2205 3.74199 28.242 3.76542 28.2661C3.89041 28.3924 4.01801 28.5186 4.14821 28.6422C4.2029 28.6932 4.26019 28.7416 4.31487 28.7926C4.41643 28.884 4.51798 28.9753 4.62214 29.0639C4.68725 29.1203 4.75495 29.1714 4.82005 29.2251C4.919 29.3057 5.01535 29.3836 5.1143 29.4615C5.18461 29.5152 5.26013 29.5689 5.33304 29.62C5.432 29.6925 5.52834 29.7623 5.6299 29.8322C5.70542 29.8859 5.78354 29.9342 5.86166 29.9853C5.96061 30.0497 6.05956 30.1142 6.16112 30.176C6.24185 30.2243 6.32257 30.2727 6.4059 30.321C6.50746 30.3801 6.60901 30.4392 6.71317 30.4956C6.7965 30.5413 6.88243 30.5843 6.96576 30.6299C7.06992 30.6837 7.17409 30.7374 7.28085 30.7884C7.36678 30.8287 7.45532 30.8717 7.54125 30.9093C7.64802 30.9577 7.75478 31.0033 7.86415 31.049C7.95269 31.0866 8.04122 31.1215 8.13236 31.1564C8.24173 31.1994 8.35371 31.2397 8.46308 31.28C8.55422 31.3122 8.64275 31.3445 8.7365 31.374C8.84847 31.4116 8.96305 31.4465 9.07762 31.4815C9.16877 31.5083 9.25991 31.5379 9.35365 31.562C9.47083 31.5943 9.58801 31.6238 9.7078 31.6507C9.79894 31.6722 9.89008 31.6963 9.98382 31.7151C10.1062 31.742 10.2286 31.7635 10.3536 31.7877C10.4447 31.8038 10.5333 31.8226 10.6244 31.8387C10.7546 31.8602 10.8848 31.8763 11.0176 31.8924C11.1036 31.9032 11.1895 31.9166 11.2754 31.9274C11.4212 31.9435 11.5697 31.9542 11.7181 31.965C11.791 31.9703 11.8639 31.9784 11.9368 31.9811C12.1582 31.9918 12.3821 31.9999 12.6087 31.9999H12.6113C12.8144 31.9999 13.0149 31.9945 13.2128 31.9838C13.2675 31.9811 13.3248 31.9757 13.3795 31.973C13.5279 31.965 13.6737 31.9515 13.8195 31.9381C13.8794 31.9327 13.9393 31.9247 13.9992 31.9193C14.1424 31.9032 14.2831 31.8844 14.4237 31.8629C14.481 31.8548 14.5409 31.8468 14.5981 31.836C14.7388 31.8118 14.8794 31.7877 15.0174 31.7581C15.0747 31.7474 15.132 31.7366 15.1893 31.7232C15.3117 31.6963 15.434 31.6668 15.5538 31.6372C19.8531 30.5628 23.0482 27.1997 24.5143 23.2726C24.5221 23.2511 24.5299 23.2296 24.5377 23.2081C26.837 16.9548 28.777 6.06787 28.777 6.06787C28.777 6.06787 21.1941 16.8715 13.9732 25.349C13.8352 25.5182 13.6998 25.6794 13.5617 25.8379Z",
    fill: "url(#paint2_linear_13237_5564)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3827 26.6206H54.0054L52.0626 21.4825H44.2916L42.4638 26.6206H40.0737L47.1035 8.2921H49.3274L56.3827 26.6206ZM51.3597 19.5525L48.4839 11.7431C48.3901 11.4874 48.2964 11.0784 48.2027 10.5161H48.1515C48.0663 11.0358 47.9683 11.4448 47.8576 11.7431L45.0073 19.5525H51.3597Z",
    fill: "#E82C2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0924 26.6206V8.2921H64.1538C70.6126 8.2921 73.8421 11.2702 73.8421 17.2263C73.8421 20.0552 72.9431 22.3303 71.1452 24.0515C69.3558 25.7642 66.9572 26.6206 63.9493 26.6206H59.0924ZM61.2397 10.2349V24.6778H63.9749C66.3778 24.6778 68.2481 24.0345 69.5859 22.7478C70.9237 21.4612 71.5925 19.6377 71.5925 17.2774C71.5925 12.5824 69.0959 10.2349 64.1027 10.2349H61.2397Z",
    fill: "#E82C2A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4323 8.2921L83.6454 26.6206H81.2808L74.6345 8.2921H77.0246L82.0988 22.8245C82.2607 23.2932 82.3843 23.8342 82.4695 24.4477H82.5206C82.5888 23.9365 82.7294 23.3869 82.9424 22.7989L88.1188 8.2921H90.4323Z",
    fill: "#E82C2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.719 26.6206H103.341L101.399 21.4825H93.6276L91.7999 26.6206H89.4098L96.4395 8.2921H98.6635L105.719 26.6206ZM100.696 19.5525L97.8199 11.7431C97.7262 11.4874 97.6324 11.0784 97.5387 10.5161H97.4876C97.4024 11.0358 97.3044 11.4448 97.1936 11.7431L94.3434 19.5525H100.696Z",
    fill: "#E82C2A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.204 26.6206H120.571L111.138 12.0115C110.899 11.6451 110.703 11.2616 110.55 10.8612H110.473C110.542 11.2531 110.576 12.0924 110.576 13.3791V26.6206H108.428V8.2921H111.215L120.392 22.6711C120.775 23.2676 121.022 23.6766 121.133 23.8981H121.184C121.099 23.3698 121.056 22.4709 121.056 21.2013V8.2921H123.204V26.6206Z",
    fill: "#E82C2A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.484 25.8537C139.129 26.5694 137.442 26.9273 135.423 26.9273C132.815 26.9273 130.728 26.088 129.16 24.4094C127.592 22.7308 126.808 20.5281 126.808 17.8014C126.808 14.8702 127.69 12.5014 129.454 10.695C131.218 8.88857 133.454 7.98535 136.164 7.98535C137.902 7.98535 139.342 8.23672 140.484 8.73945V11.0273C139.172 10.2945 137.723 9.92812 136.138 9.92812C134.034 9.92812 132.325 10.6311 131.013 12.037C129.709 13.443 129.058 15.3218 129.058 17.6736C129.058 19.9061 129.667 21.687 130.885 23.0162C132.112 24.337 133.718 24.9973 135.704 24.9973C137.544 24.9973 139.138 24.5883 140.484 23.7703V25.8537Z",
    fill: "#E82C2A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.93 26.6206H144.216V8.2921H153.521V10.2349H146.363V16.3316H152.984V18.2616H146.363V24.6778H153.93V26.6206Z",
    fill: "#E82C2A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13237_5564",
    x1: 13.3421,
    y1: 32.7696,
    x2: 23.8748,
    y2: 12.3456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8284,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9206,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13237_5564",
    x1: 27.5177,
    y1: 32.0007,
    x2: 30.3795,
    y2: 8.27428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3511,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6439,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8225,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9117,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9625,
    stopColor: "#FBB040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13237_5564",
    x1: 3.14658,
    y1: 32.6187,
    x2: 30.0955,
    y2: 32.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#EF4136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9214,
    stopColor: "#F68B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9434,
    stopColor: "#F78E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9655,
    stopColor: "#F89627"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9875,
    stopColor: "#FAA535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceLogo);
export default __webpack_public_path__ + "static/media/advance-logo.cb431086b4b58d98d3e04ee6374cf223.svg";
export { ForwardRef as ReactComponent };